const fallbackWidth = '24';
const fallbackHeight = '24';

export const TableViewIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Top Row */}
      <rect x="4" y="5" width="16" height="3" rx="1.5" fill="currentColor" />

      {/* Middle Row */}
      <rect x="4" y="10.5" width="16" height="3" rx="1.5" fill="currentColor" />

      {/* Bottom Row */}
      <rect x="4" y="16" width="16" height="3" rx="1.5" fill="currentColor" />
    </svg>
  );
};

export const BoardViewIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Column 1 */}
      <rect x="4" y="5" width="4" height="14" rx="1.5" fill="currentColor" />

      {/* Column 2 */}
      <rect x="10" y="5" width="4" height="10" rx="1.5" fill="currentColor" />

      {/* Column 3 */}
      <rect x="16" y="5" width="4" height="7" rx="1.5" fill="currentColor" />
    </svg>
  );
};

export const AngleRightIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5402 11.29L9.88023 5.64004C9.78726 5.54631 9.67666 5.47191 9.5548 5.42115C9.43294 5.37038 9.30224 5.34424 9.17023 5.34424C9.03821 5.34424 8.90751 5.37038 8.78565 5.42115C8.66379 5.47191 8.55319 5.54631 8.46023 5.64004C8.27398 5.8274 8.16943 6.08085 8.16943 6.34504C8.16943 6.60922 8.27398 6.86267 8.46023 7.05004L13.4102 12.05L8.46023 17C8.27398 17.1874 8.16943 17.4409 8.16943 17.705C8.16943 17.9692 8.27398 18.2227 8.46023 18.41C8.55284 18.5045 8.66329 18.5797 8.78516 18.6312C8.90704 18.6827 9.03792 18.7095 9.17023 18.71C9.30253 18.7095 9.43342 18.6827 9.55529 18.6312C9.67717 18.5797 9.78761 18.5045 9.88023 18.41L15.5402 12.76C15.6417 12.6664 15.7227 12.5527 15.7781 12.4262C15.8336 12.2997 15.8622 12.1631 15.8622 12.025C15.8622 11.8869 15.8336 11.7503 15.7781 11.6238C15.7227 11.4973 15.6417 11.3837 15.5402 11.29Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AngleLeftIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5002 12.7998L14.2002 18.3998C14.6002 18.7998 15.2002 18.7998 15.6002 18.3998C16.0002 17.9998 16.0002 17.3998 15.6002 16.9998L10.7002 11.9998L15.6002 6.9998C16.0002 6.5998 16.0002 5.9998 15.6002 5.5998C15.4002 5.3998 15.2002 5.2998 14.9002 5.2998C14.6002 5.2998 14.4002 5.3998 14.2002 5.5998L8.5002 11.1998C8.1002 11.6998 8.1002 12.2998 8.5002 12.7998C8.5002 12.6998 8.5002 12.6998 8.5002 12.7998Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AngleUpIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 15L12 9L6 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AngleDownIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IntegrationIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2473 5.13328L4.13379 11.2468L7.66083 14.7739C9.34904 16.4621 12.0862 16.4621 13.7744 14.7739C15.4626 13.0857 15.4626 10.3485 13.7744 8.66033L10.2473 5.13328Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M5.21183 9.50382L3 7.29199"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M8.50382 6.21183L6.29199 4"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M13.7734 14.7739L15.1843 16.1847L19.9996 21.0001"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M3.19336 12.1873L11.188 4.19262"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const HomeIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.825 18.9586H5.17496C2.89163 18.9586 1.04163 17.1003 1.04163 14.817V8.64197C1.04163 7.50864 1.74163 6.08364 2.64163 5.38364L7.13329 1.88364C8.48329 0.833637 10.6416 0.783637 12.0416 1.76697L17.1916 5.3753C18.1833 6.06697 18.9583 7.5503 18.9583 8.75864V14.8253C18.9583 17.1003 17.1083 18.9586 14.825 18.9586ZM7.89996 2.86697L3.40829 6.36697C2.81663 6.83364 2.29163 7.89197 2.29163 8.64197V14.817C2.29163 16.4086 3.58329 17.7086 5.17496 17.7086H14.825C16.4166 17.7086 17.7083 16.417 17.7083 14.8253V8.75864C17.7083 7.95864 17.1333 6.8503 16.475 6.4003L11.325 2.79197C10.375 2.1253 8.80829 2.15864 7.89996 2.86697Z"
        fill="currentColor"
      />
      <path
        d="M10 15.625C9.65833 15.625 9.375 15.3417 9.375 15V12.5C9.375 12.1583 9.65833 11.875 10 11.875C10.3417 11.875 10.625 12.1583 10.625 12.5V15C10.625 15.3417 10.3417 15.625 10 15.625Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const UserIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0015 10.6253C7.35984 10.6253 5.20984 8.47533 5.20984 5.83366C5.20984 3.19199 7.35984 1.04199 10.0015 1.04199C12.6432 1.04199 14.7932 3.19199 14.7932 5.83366C14.7932 8.47533 12.6432 10.6253 10.0015 10.6253ZM10.0015 2.29199C8.05151 2.29199 6.45984 3.88366 6.45984 5.83366C6.45984 7.78366 8.05151 9.37533 10.0015 9.37533C11.9515 9.37533 13.5432 7.78366 13.5432 5.83366C13.5432 3.88366 11.9515 2.29199 10.0015 2.29199Z"
        fill="currentColor"
      />
      <path
        d="M17.1599 18.9583C16.8183 18.9583 16.5349 18.675 16.5349 18.3333C16.5349 15.4583 13.6016 13.125 10.0016 13.125C6.40159 13.125 3.46826 15.4583 3.46826 18.3333C3.46826 18.675 3.18493 18.9583 2.84326 18.9583C2.5016 18.9583 2.21826 18.675 2.21826 18.3333C2.21826 14.775 5.70993 11.875 10.0016 11.875C14.2933 11.875 17.7849 14.775 17.7849 18.3333C17.7849 18.675 17.5016 18.9583 17.1599 18.9583Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ProviderIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 5L19 2M19 2L22 5M19 2V8M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14551 19.9263C2.61465 18.2386 4.16256 17 5.99977 17H12.9998C13.9291 17 14.3937 17 14.7801 17.0769C16.3669 17.3925 17.6073 18.6329 17.9229 20.2196C17.9998 20.606 17.9998 21.0707 17.9998 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PaymentIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 15H10C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13H7C6.73478 13 6.48043 13.1054 6.29289 13.2929C6.10536 13.4804 6 13.7348 6 14C6 14.2652 6.10536 14.5196 6.29289 14.7071C6.48043 14.8946 6.73478 15 7 15ZM19 5H5C4.20435 5 3.44129 5.31607 2.87868 5.87868C2.31607 6.44129 2 7.20435 2 8V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V8C22 7.20435 21.6839 6.44129 21.1213 5.87868C20.5587 5.31607 19.7956 5 19 5ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V11H20V17ZM20 9H4V8C4 7.73478 4.10536 7.48043 4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H19C19.2652 7 19.5196 7.10536 19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V9Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CommitionIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75778 10.7578C8.35113 10.7578 8.93115 10.5818 9.4245 10.2522C9.91784 9.92255 10.3024 9.45401 10.5294 8.90583C10.7565 8.35766 10.8159 7.75446 10.7001 7.17251C10.5844 6.59057 10.2987 6.05602 9.87911 5.63646C9.45955 5.21691 8.925 4.93118 8.34306 4.81543C7.76111 4.69967 7.15791 4.75908 6.60973 4.98615C6.06156 5.21321 5.59302 5.59773 5.26338 6.09107C4.93373 6.58442 4.75778 7.16444 4.75778 7.75778C4.75865 8.55317 5.075 9.31572 5.63742 9.87814C6.19984 10.4406 6.9624 10.7569 7.75778 10.7578ZM7.75778 6.75778C7.95557 6.75778 8.14891 6.81643 8.31335 6.92631C8.4778 7.0362 8.60598 7.19237 8.68166 7.3751C8.75735 7.55783 8.77715 7.75889 8.73857 7.95287C8.69998 8.14686 8.60474 8.32504 8.46489 8.46489C8.32504 8.60474 8.14686 8.69998 7.95287 8.73857C7.75889 8.77715 7.55783 8.75735 7.3751 8.68166C7.19237 8.60598 7.0362 8.4778 6.92632 8.31335C6.81643 8.1489 6.75778 7.95557 6.75778 7.75778C6.75796 7.49262 6.86338 7.23837 7.05087 7.05087C7.23837 6.86337 7.49262 6.75796 7.75778 6.75778ZM16.2422 13.2422C15.6488 13.2422 15.0688 13.4181 14.5755 13.7478C14.0821 14.0774 13.6976 14.5459 13.4705 15.0941C13.2435 15.6423 13.1841 16.2455 13.2998 16.8274C13.4156 17.4094 13.7013 17.9439 14.1208 18.3635C14.5404 18.783 15.075 19.0688 15.6569 19.1845C16.2388 19.3003 16.842 19.2409 17.3902 19.0138C17.9384 18.7867 18.4069 18.4022 18.7366 17.9089C19.0662 17.4155 19.2422 16.8355 19.2422 16.2422C19.2413 15.4468 18.9249 14.6842 18.3625 14.1218C17.8001 13.5594 17.0375 13.243 16.2422 13.2422ZM16.2422 17.2422C16.0444 17.2422 15.851 17.1835 15.6866 17.0736C15.5221 16.9638 15.394 16.8076 15.3183 16.6248C15.2426 16.4421 15.2228 16.2411 15.2614 16.0471C15.3 15.8531 15.3952 15.6749 15.5351 15.5351C15.6749 15.3952 15.8531 15.3 16.0471 15.2614C16.2411 15.2228 16.4421 15.2426 16.6248 15.3183C16.8076 15.394 16.9638 15.5221 17.0736 15.6866C17.1835 15.851 17.2422 16.0444 17.2422 16.2422C17.242 16.5073 17.1366 16.7616 16.9491 16.9491C16.7616 17.1366 16.5073 17.242 16.2422 17.2422ZM19.707 4.29297C19.6141 4.20009 19.5039 4.12641 19.3826 4.07614C19.2613 4.02587 19.1313 4 18.9999 4C18.8686 4 18.7386 4.02587 18.6173 4.07614C18.496 4.12641 18.3857 4.20009 18.2929 4.29297L4.29291 18.293C4.19911 18.3856 4.12455 18.4959 4.07353 18.6174C4.0225 18.739 3.99602 18.8695 3.99561 19.0013C3.9952 19.1331 4.02086 19.2638 4.07112 19.3856C4.12139 19.5075 4.19526 19.6182 4.28848 19.7115C4.38171 19.8047 4.49245 19.8786 4.61433 19.9288C4.73621 19.9791 4.86683 20.0047 4.99866 20.0043C5.1305 20.0039 5.26095 19.9774 5.38251 19.9264C5.50407 19.8753 5.61434 19.8008 5.70697 19.707L19.707 5.70697C19.7998 5.61414 19.8735 5.50393 19.9238 5.38262C19.974 5.26131 19.9999 5.13128 19.9999 4.99997C19.9999 4.86866 19.974 4.73864 19.9238 4.61733C19.8735 4.49602 19.7998 4.3858 19.707 4.29297Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ChargesIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 17.0601H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.21997 13.5H9.78003C11.56 13.5 12 13.94 12 15.7V19.81C12 21.57 11.56 22.01 9.78003 22.01H4.21997C2.43997 22.01 2 21.57 2 19.81V15.7C2 13.94 2.43997 13.5 4.21997 13.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M2 9C2 5.13 5.13 2 9 2L7.95001 3.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 11C20.9853 11 23 8.98528 23 6.5C23 4.01472 20.9853 2 18.5 2C16.0147 2 14 4.01472 14 6.5C14 8.98528 16.0147 11 18.5 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DiscountIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.002 22.0391C17.5248 22.0391 22.002 17.5619 22.002 12.0391C22.002 6.51621 17.5248 2.03906 12.002 2.03906C6.47911 2.03906 2.00195 6.51621 2.00195 12.0391C2.00195 17.5619 6.47911 22.0391 12.002 22.0391Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.00195 15.0391L15.002 9.03906"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M14.4965 14.5391H14.5054"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.49646 9.53906H9.50544"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ServerIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 14H4C2.89543 14 2 14.8954 2 16V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V16C22 14.8954 21.1046 14 20 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 18H6.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 2H4C2.89543 2 2 2.89543 2 4V8C2 9.10457 2.89543 10 4 10H20C21.1046 10 22 9.10457 22 8V4C22 2.89543 21.1046 2 20 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6H6.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ServiceIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5295 8.35186C12.9571 8.75995 12.2566 9 11.5 9C9.567 9 8 7.433 8 5.5C8 3.567 9.567 2 11.5 2C12.753 2 13.8522 2.65842 14.4705 3.64814M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2086L12.3769 20.8789C12.9753 21.0247 13.5988 21.0388 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7854 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4134 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2091C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1417C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M20 6.5C20 8.433 18.433 10 16.5 10C14.567 10 13 8.433 13 6.5C13 4.567 14.567 3 16.5 3C18.433 3 20 4.567 20 6.5ZM2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7951 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.0399 6 13.7599 5.89101 13.546C5.79513 13.3578 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13L3.6 13C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3578 2.10899 13.546C2 13.7599 2 14.0399 2 14.6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CitiesIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 22H5C3 22 2 21 2 19V11C2 9 3 8 5 8H10V19C10 21 11 22 13 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10.11 4C10.03 4.3 10 4.63 10 5V8H5V6C5 4.9 5.9 4 7 4H10.11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M14 8V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M18 8V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 17H15C14.45 17 14 17.45 14 18V22H18V18C18 17.45 17.55 17 17 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6 13V17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 19V5C10 3 11 2 13 2H19C21 2 22 3 22 5V19C22 21 21 22 19 22H13C11 22 10 21 10 19Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const GeneralIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.32C13.19 9.32 14.16 8.35 14.16 7.16C14.16 5.97 13.19 5 12 5C10.81 5 9.84003 5.97 9.84003 7.16C9.84003 8.35 10.81 9.32 12 9.32Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.79 19.0002C7.98 19.0002 8.95 18.0302 8.95 16.8402C8.95 15.6502 7.98 14.6802 6.79 14.6802C5.6 14.6802 4.63 15.6502 4.63 16.8402C4.63 18.0302 5.59 19.0002 6.79 19.0002Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.21 19.0002C18.4 19.0002 19.37 18.0302 19.37 16.8402C19.37 15.6502 18.4 14.6802 17.21 14.6802C16.02 14.6802 15.05 15.6502 15.05 16.8402C15.05 18.0302 16.02 19.0002 17.21 19.0002Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ProductIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7584 12.517C12.275 12.517 11.75 12.3587 11.225 12.0337L10.125 11.367C10.075 11.3337 9.92504 11.3337 9.87504 11.367L8.77504 12.0337C7.87504 12.5837 6.99171 12.667 6.28337 12.267C5.59171 11.8753 5.20837 11.092 5.20837 10.067V4.19199C5.20837 2.15866 6.31671 1.04199 8.33337 1.04199H11.6667C13.6834 1.04199 14.7917 2.15866 14.7917 4.19199V10.067C14.7917 11.1003 14.4084 11.8837 13.7167 12.267C13.425 12.4337 13.1 12.517 12.7584 12.517ZM10 10.092C10.275 10.092 10.55 10.1587 10.775 10.292L11.875 10.9587C12.3667 11.2587 12.8167 11.3337 13.1 11.1753C13.375 11.017 13.5334 10.6087 13.5334 10.0587V4.19199C13.5334 2.85866 12.975 2.29199 11.6584 2.29199H8.32504C7.00837 2.29199 6.45004 2.85866 6.45004 4.19199V10.067C6.45004 10.617 6.60837 11.0253 6.88337 11.1837C7.16671 11.342 7.61671 11.267 8.10837 10.967L9.20837 10.3003C9.45004 10.1587 9.72504 10.092 10 10.092Z"
        fill="currentColor"
      />
      <path
        d="M12.5 18.9582H7.49996C2.97496 18.9582 1.04163 17.0082 1.04163 12.4415V9.91651C1.04163 6.03318 2.44163 4.06651 5.57496 3.54151C5.90829 3.48318 6.23329 3.71651 6.29163 4.05818C6.34996 4.39984 6.11663 4.71651 5.77496 4.77484C3.26663 5.19151 2.28329 6.63318 2.28329 9.91651V12.4415C2.28329 16.2832 3.69163 17.7082 7.49163 17.7082H12.4916C16.2916 17.7082 17.7 16.2832 17.7 12.4415V9.91651C17.7 6.58318 16.6833 5.14151 14.0666 4.74984C13.725 4.69984 13.4916 4.38318 13.5416 4.04151C13.5916 3.69984 13.9083 3.46651 14.25 3.51651C17.5 3.99984 18.95 5.96651 18.95 9.91651V12.4415C18.9583 17.0082 17.025 18.9582 12.5 18.9582Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const VendorIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M3 7C3 8.65685 4.34315 10 6 10C7.65685 10 9 8.65685 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 8.65685 16.3431 10 18 10C19.6569 10 21 8.65685 21 7M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InventryIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M2 9C2 5.13 5.13 2 9 2L7.95 3.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7002 4.4502L17.6802 6.75018L21.6202 4.46021"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6802 10.8203V6.74023"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7401 2.21L14.3401 3.53996C13.8001 3.83996 13.3501 4.59995 13.3501 5.21995V7.75999C13.3501 8.37999 13.7901 9.13998 14.3401 9.43998L16.7401 10.77C17.2501 11.06 18.0901 11.06 18.6101 10.77L21.0101 9.43998C21.5501 9.13998 22.0001 8.37999 22.0001 7.75999V5.21995C22.0001 4.59995 21.5601 3.83996 21.0101 3.53996L18.6101 2.21C18.1001 1.93 17.2601 1.93 16.7401 2.21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.3501 15.4502L6.3201 17.7502L10.2701 15.4602"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.32031 21.8203V17.7402"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.39 13.21L2.99001 14.54C2.45001 14.84 2 15.5999 2 16.2199V18.76C2 19.38 2.44001 20.14 2.99001 20.44L5.39 21.77C5.9 22.06 6.73999 22.06 7.25999 21.77L9.66 20.44C10.2 20.14 10.65 19.38 10.65 18.76V16.2199C10.65 15.5999 10.21 14.84 9.66 14.54L7.25999 13.21C6.73999 12.93 5.9 12.93 5.39 13.21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PackageIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99991 11.0834C9.89157 11.0834 9.78324 11.0584 9.68324 11L2.32491 6.74171C2.03324 6.56671 1.92491 6.18338 2.09991 5.88338C2.27491 5.58338 2.65824 5.48338 2.95824 5.65838L9.99991 9.73338L16.9999 5.68338C17.2999 5.50838 17.6832 5.61671 17.8582 5.90838C18.0332 6.20838 17.9249 6.59171 17.6332 6.76671L10.3249 11C10.2166 11.05 10.1082 11.0834 9.99991 11.0834Z"
        fill="currentColor"
      />
      <path
        d="M10 18.6335C9.65833 18.6335 9.375 18.3502 9.375 18.0085V10.4502C9.375 10.1085 9.65833 9.8252 10 9.8252C10.3417 9.8252 10.625 10.1085 10.625 10.4502V18.0085C10.625 18.3502 10.3417 18.6335 10 18.6335Z"
        fill="currentColor"
      />
      <path
        d="M10 18.9587C9.2667 18.9587 8.5417 18.8003 7.9667 18.4837L3.5167 16.0087C2.30837 15.342 1.3667 13.7337 1.3667 12.3503V7.64199C1.3667 6.25866 2.30837 4.65866 3.5167 3.98366L7.9667 1.51699C9.10837 0.883659 10.8917 0.883659 12.0334 1.51699L16.4834 3.99199C17.6917 4.65866 18.6334 6.26699 18.6334 7.65033V12.3587C18.6334 13.742 17.6917 15.342 16.4834 16.017L12.0334 18.4837C11.4584 18.8003 10.7334 18.9587 10 18.9587ZM10 2.29199C9.47503 2.29199 8.95837 2.40033 8.57503 2.60866L4.12503 5.08366C3.32503 5.52533 2.6167 6.72533 2.6167 7.64199V12.3503C2.6167 13.267 3.32503 14.467 4.12503 14.917L8.57503 17.392C9.33337 17.817 10.6667 17.817 11.425 17.392L15.875 14.917C16.675 14.467 17.3834 13.2753 17.3834 12.3503V7.64199C17.3834 6.72533 16.675 5.52533 15.875 5.07533L11.425 2.60033C11.0417 2.40033 10.525 2.29199 10 2.29199Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const DIDIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5416 18.9587C13.6 18.9587 12.6083 18.7337 11.5833 18.3003C10.5833 17.8753 9.57496 17.292 8.59163 16.5837C7.61663 15.867 6.67496 15.067 5.78329 14.192C4.89996 13.3003 4.09996 12.3587 3.39163 11.392C2.67496 10.392 2.09996 9.39199 1.69163 8.42532C1.25829 7.39199 1.04163 6.39199 1.04163 5.45033C1.04163 4.80033 1.15829 4.18366 1.38329 3.60866C1.61663 3.01699 1.99163 2.46699 2.49996 1.99199C3.14163 1.35866 3.87496 1.04199 4.65829 1.04199C4.98329 1.04199 5.31663 1.11699 5.59996 1.25033C5.92496 1.40033 6.19996 1.62533 6.39996 1.92533L8.33329 4.65033C8.50829 4.89199 8.64163 5.12533 8.73329 5.35866C8.84163 5.60866 8.89996 5.85866 8.89996 6.10033C8.89996 6.41699 8.80829 6.72533 8.63329 7.01699C8.50829 7.24199 8.31663 7.48366 8.07496 7.72533L7.50829 8.31699C7.51663 8.34199 7.52496 8.35866 7.53329 8.37533C7.63329 8.55033 7.83329 8.85033 8.21663 9.30033C8.62496 9.76699 9.00829 10.192 9.39163 10.5837C9.88329 11.067 10.2916 11.4503 10.675 11.767C11.15 12.167 11.4583 12.367 11.6416 12.4587L11.625 12.5003L12.2333 11.9003C12.4916 11.642 12.7416 11.4503 12.9833 11.3253C13.4416 11.042 14.025 10.992 14.6083 11.2337C14.825 11.3253 15.0583 11.4503 15.3083 11.6253L18.075 13.592C18.3833 13.8003 18.6083 14.067 18.7416 14.3837C18.8666 14.7003 18.925 14.992 18.925 15.2837C18.925 15.6837 18.8333 16.0837 18.6583 16.4587C18.4833 16.8337 18.2666 17.1587 17.9916 17.4587C17.5166 17.9837 17 18.3587 16.4 18.6003C15.825 18.8337 15.2 18.9587 14.5416 18.9587ZM4.65829 2.29199C4.19996 2.29199 3.77496 2.49199 3.36663 2.89199C2.98329 3.25033 2.71663 3.64199 2.54996 4.06699C2.37496 4.50033 2.29163 4.95866 2.29163 5.45033C2.29163 6.22533 2.47496 7.06699 2.84163 7.93366C3.21663 8.81699 3.74163 9.73366 4.40829 10.6503C5.07496 11.567 5.83329 12.4587 6.66663 13.3003C7.49996 14.1253 8.39996 14.892 9.32496 15.567C10.225 16.2253 11.15 16.7587 12.0666 17.142C13.4916 17.7503 14.825 17.892 15.925 17.4337C16.35 17.2587 16.725 16.992 17.0666 16.6087C17.2583 16.4003 17.4083 16.1753 17.5333 15.9087C17.6333 15.7003 17.6833 15.4837 17.6833 15.267C17.6833 15.1337 17.6583 15.0003 17.5916 14.8503C17.5666 14.8003 17.5166 14.7087 17.3583 14.6003L14.5916 12.6337C14.425 12.517 14.275 12.4337 14.1333 12.3753C13.95 12.3003 13.875 12.2253 13.5916 12.4003C13.425 12.4837 13.275 12.6087 13.1083 12.7753L12.475 13.4003C12.15 13.717 11.65 13.792 11.2666 13.6503L11.0416 13.5503C10.7 13.367 10.3 13.0837 9.85829 12.7087C9.45829 12.367 9.02496 11.967 8.49996 11.4503C8.09163 11.0337 7.68329 10.592 7.25829 10.1003C6.86663 9.64199 6.58329 9.25033 6.40829 8.92533L6.30829 8.67533C6.25829 8.48366 6.24163 8.37533 6.24163 8.25866C6.24163 7.95866 6.34996 7.69199 6.55829 7.48366L7.18329 6.83366C7.34996 6.66699 7.47496 6.50866 7.55829 6.36699C7.62496 6.25866 7.64996 6.16699 7.64996 6.08366C7.64996 6.01699 7.62496 5.91699 7.58329 5.81699C7.52496 5.68366 7.43329 5.53366 7.31663 5.37533L5.38329 2.64199C5.29996 2.52533 5.19996 2.44199 5.07496 2.38366C4.94163 2.32533 4.79996 2.29199 4.65829 2.29199ZM11.625 12.5087L11.4916 13.0753L11.7166 12.492C11.675 12.4837 11.6416 12.492 11.625 12.5087Z"
        fill="currentColor"
      />
      <path
        d="M15.4167 8.12467C15.075 8.12467 14.7917 7.84134 14.7917 7.49967C14.7917 7.19967 14.4917 6.57467 13.9917 6.04134C13.5 5.51634 12.9583 5.20801 12.5 5.20801C12.1583 5.20801 11.875 4.92467 11.875 4.58301C11.875 4.24134 12.1583 3.95801 12.5 3.95801C13.3083 3.95801 14.1583 4.39134 14.9 5.18301C15.5917 5.92467 16.0417 6.83301 16.0417 7.49967C16.0417 7.84134 15.7583 8.12467 15.4167 8.12467Z"
        fill="currentColor"
      />
      <path
        d="M18.3333 8.12533C17.9917 8.12533 17.7083 7.84199 17.7083 7.50033C17.7083 4.62533 15.375 2.29199 12.5 2.29199C12.1583 2.29199 11.875 2.00866 11.875 1.66699C11.875 1.32533 12.1583 1.04199 12.5 1.04199C16.0583 1.04199 18.9583 3.94199 18.9583 7.50033C18.9583 7.84199 18.675 8.12533 18.3333 8.12533Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RateIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 19.0114C6.66671 19.0114 3.95837 16.6197 3.95837 13.6781V10.5947C3.95837 10.2531 4.24171 9.96973 4.58337 9.96973C4.92504 9.96973 5.20837 10.2531 5.20837 10.5947C5.20837 12.7781 7.26671 14.4281 10 14.4281C12.7334 14.4281 14.7917 12.7781 14.7917 10.5947C14.7917 10.2531 15.075 9.96973 15.4167 9.96973C15.7584 9.96973 16.0417 10.2531 16.0417 10.5947V13.6781C16.0417 16.6197 13.3334 19.0114 10 19.0114ZM5.20837 13.7697C5.26671 15.9781 7.39171 17.7614 10 17.7614C12.6084 17.7614 14.7334 15.9781 14.7917 13.7697C13.7084 14.9447 11.9917 15.6781 10 15.6781C8.00837 15.6781 6.30004 14.9447 5.20837 13.7697Z"
        fill="currentColor"
      />
      <path
        d="M10 11.5114C7.70004 11.5114 5.63336 10.4781 4.62503 8.81139C4.1917 8.10306 3.95837 7.27806 3.95837 6.42806C3.95837 4.99473 4.60004 3.64473 5.75838 2.62806C6.89171 1.63639 8.40004 1.09473 10 1.09473C11.6 1.09473 13.1 1.63639 14.2417 2.61973C15.4 3.64473 16.0417 4.99473 16.0417 6.42806C16.0417 7.27806 15.8084 8.09473 15.3751 8.81139C14.3667 10.4781 12.3 11.5114 10 11.5114ZM10 2.34473C8.70004 2.34473 7.48339 2.77806 6.57505 3.57806C5.69172 4.34473 5.20837 5.36139 5.20837 6.42806C5.20837 7.05306 5.37503 7.63639 5.6917 8.16139C6.48336 9.46139 8.13337 10.2614 10 10.2614C11.8667 10.2614 13.5167 9.45306 14.3084 8.16139C14.6334 7.63639 14.7917 7.05306 14.7917 6.42806C14.7917 5.36139 14.3084 4.34473 13.4167 3.56139C12.5084 2.77806 11.3 2.34473 10 2.34473Z"
        fill="currentColor"
      />
      <path
        d="M10 15.6781C6.55837 15.6781 3.95837 13.4947 3.95837 10.5947V6.42806C3.95837 3.48639 6.66671 1.09473 10 1.09473C11.6 1.09473 13.1 1.63639 14.2417 2.61973C15.4 3.64473 16.0417 4.99473 16.0417 6.42806V10.5947C16.0417 13.4947 13.4417 15.6781 10 15.6781ZM10 2.34473C7.35837 2.34473 5.20837 4.17806 5.20837 6.42806V10.5947C5.20837 12.7781 7.26671 14.4281 10 14.4281C12.7334 14.4281 14.7917 12.7781 14.7917 10.5947V6.42806C14.7917 5.36139 14.3084 4.34473 13.4167 3.56139C12.5084 2.77806 11.3 2.34473 10 2.34473Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BillingIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99988 18.5418C9.31655 18.5418 8.63321 18.3251 8.06654 17.9001L3.72488 14.6501C2.91655 14.0418 2.43323 13.0751 2.43323 12.0668V1.4668H17.5665V12.0668C17.5665 13.0751 17.0832 14.0418 16.2749 14.6501L11.9332 17.9001C11.3666 18.3251 10.6832 18.5418 9.99988 18.5418ZM3.68323 2.70847V12.0585C3.68323 12.6751 3.98321 13.2668 4.47488 13.6418L8.81654 16.8918C9.51654 17.4168 10.4915 17.4168 11.1915 16.8918L15.5332 13.6418C16.0249 13.2668 16.3249 12.6751 16.3249 12.0585V2.70847H3.68323Z"
        fill="currentColor"
      />
      <path
        d="M18.3333 2.70801H1.66663C1.32496 2.70801 1.04163 2.42467 1.04163 2.08301C1.04163 1.74134 1.32496 1.45801 1.66663 1.45801H18.3333C18.675 1.45801 18.9583 1.74134 18.9583 2.08301C18.9583 2.42467 18.675 2.70801 18.3333 2.70801Z"
        fill="currentColor"
      />
      <path
        d="M13.3333 7.29199H6.66663C6.32496 7.29199 6.04163 7.00866 6.04163 6.66699C6.04163 6.32533 6.32496 6.04199 6.66663 6.04199H13.3333C13.675 6.04199 13.9583 6.32533 13.9583 6.66699C13.9583 7.00866 13.675 7.29199 13.3333 7.29199Z"
        fill="currentColor"
      />
      <path
        d="M13.3333 11.458H6.66663C6.32496 11.458 6.04163 11.1747 6.04163 10.833C6.04163 10.4913 6.32496 10.208 6.66663 10.208H13.3333C13.675 10.208 13.9583 10.4913 13.9583 10.833C13.9583 11.1747 13.675 11.458 13.3333 11.458Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Billing1Icon = ({ width = 24, height = 24, fill = 'black' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1231_74)">
      <mask
        id="mask0_1231_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="512"
        height="512"
      >
        <path d="M512 0H0V512H512V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1231_74)">
        <path
          d="M504 424H464V80C463.977 58.7898 455.541 38.455 440.543 23.4572C425.545 8.45932 405.21 0.0232928 384 0H80C58.7898 0.0232928 38.455 8.45932 23.4572 23.4572C8.45932 38.455 0.0232928 58.7898 0 80C0 82.1217 0.842855 84.1566 2.34315 85.6569C3.84344 87.1571 5.87827 88 8 88H144L144.536 437.932C144.536 440.054 145.379 442.089 146.879 443.589C148.379 445.089 150.414 445.932 152.536 445.932C154.658 445.932 156.693 445.089 158.193 443.589C159.693 442.089 160.536 440.054 160.536 437.932L160 80C159.988 67.5606 157.07 55.296 151.478 44.1843C145.886 33.0726 137.775 23.4213 127.792 16H384C400.968 16.0191 417.236 22.768 429.234 34.7662C441.232 46.7644 447.981 63.032 448 80V424H296C293.878 424 291.843 424.843 290.343 426.343C288.843 427.843 288 429.878 288 432C288.007 446.348 283.193 460.283 274.329 471.566C265.466 482.849 253.069 490.827 239.127 494.219C225.185 497.61 210.508 496.218 197.453 490.266C184.397 484.315 173.72 474.148 167.136 461.4C166.16 459.516 164.476 458.097 162.453 457.455C160.431 456.812 158.236 457 156.352 457.976C154.468 458.952 153.049 460.636 152.407 462.659C151.764 464.681 151.952 466.876 152.928 468.76C159.651 481.808 169.843 492.748 182.382 500.377C194.921 508.005 209.322 512.027 224 512H432C453.21 511.977 473.545 503.541 488.543 488.543C503.541 473.545 511.977 453.21 512 432C512 429.878 511.157 427.843 509.657 426.343C508.157 424.843 506.122 424 504 424ZM143.496 72H16.496C18.4411 56.5308 25.9661 42.3035 37.6581 31.9896C49.3501 21.6756 64.405 15.9844 79.996 15.9844C95.5871 15.9844 110.642 21.6756 122.334 31.9896C134.026 42.3035 141.551 56.5308 143.496 72ZM432 496H271.92C280.789 489.367 288.185 480.965 293.638 471.325C299.091 461.686 302.483 451.019 303.6 440H495.496C493.529 455.458 485.998 469.67 474.311 479.977C462.625 490.285 447.583 495.981 432 496Z"
          fill={fill}
        />
        <path
          d="M224 211.296H384C386.122 211.296 388.157 210.453 389.657 208.953C391.157 207.453 392 205.418 392 203.296C392 201.174 391.157 199.139 389.657 197.639C388.157 196.139 386.122 195.296 384 195.296H224C221.878 195.296 219.843 196.139 218.343 197.639C216.843 199.139 216 201.174 216 203.296C216 205.418 216.843 207.453 218.343 208.953C219.843 210.453 221.878 211.296 224 211.296Z"
          fill={fill}
        />
        <path
          d="M360 248.632H224C221.878 248.632 219.843 249.475 218.343 250.975C216.843 252.475 216 254.51 216 256.632C216 258.754 216.843 260.789 218.343 262.289C219.843 263.789 221.878 264.632 224 264.632H360C362.122 264.632 364.157 263.789 365.657 262.289C367.157 260.789 368 258.754 368 256.632C368 254.51 367.157 252.475 365.657 250.975C364.157 249.475 362.122 248.632 360 248.632Z"
          fill={fill}
        />
        <path
          d="M328 301.96H224C221.878 301.96 219.843 302.803 218.343 304.303C216.843 305.803 216 307.838 216 309.96C216 312.082 216.843 314.117 218.343 315.617C219.843 317.117 221.878 317.96 224 317.96H328C330.122 317.96 332.157 317.117 333.657 315.617C335.157 314.117 336 312.082 336 309.96C336 307.838 335.157 305.803 333.657 304.303C332.157 302.803 330.122 301.96 328 301.96Z"
          fill={fill}
        />
        <path
          d="M328 355.296H224C221.878 355.296 219.843 356.139 218.343 357.639C216.843 359.139 216 361.174 216 363.296C216 365.418 216.843 367.453 218.343 368.953C219.843 370.453 221.878 371.296 224 371.296H328C330.122 371.296 332.157 370.453 333.657 368.953C335.157 367.453 336 365.418 336 363.296C336 361.174 335.157 359.139 333.657 357.639C332.157 356.139 330.122 355.296 328 355.296Z"
          fill={fill}
        />
        <path
          d="M224 104.632H384C386.122 104.632 388.157 103.789 389.657 102.289C391.157 100.789 392 98.7538 392 96.632C392 94.5103 391.157 92.4754 389.657 90.9752C388.157 89.4749 386.122 88.632 384 88.632H224C221.878 88.632 219.843 89.4749 218.343 90.9752C216.843 92.4754 216 94.5103 216 96.632C216 98.7538 216.843 100.789 218.343 102.289C219.843 103.789 221.878 104.632 224 104.632Z"
          fill={fill}
        />
        <path
          d="M224 157.96H384C386.122 157.96 388.157 157.117 389.657 155.617C391.157 154.117 392 152.082 392 149.96C392 147.838 391.157 145.803 389.657 144.303C388.157 142.803 386.122 141.96 384 141.96H224C221.878 141.96 219.843 142.803 218.343 144.303C216.843 145.803 216 147.838 216 149.96C216 152.082 216.843 154.117 218.343 155.617C219.843 157.117 221.878 157.96 224 157.96Z"
          fill={fill}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1231_74">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const SettingIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13.125C8.275 13.125 6.875 11.725 6.875 10C6.875 8.275 8.275 6.875 10 6.875C11.725 6.875 13.125 8.275 13.125 10C13.125 11.725 11.725 13.125 10 13.125ZM10 8.125C8.96667 8.125 8.125 8.96667 8.125 10C8.125 11.0333 8.96667 11.875 10 11.875C11.0333 11.875 11.875 11.0333 11.875 10C11.875 8.96667 11.0333 8.125 10 8.125Z"
        fill="currentColor"
      />
      <path
        d="M12.675 18.4913C12.5 18.4913 12.325 18.4663 12.15 18.4246C11.6333 18.2829 11.2 17.9579 10.925 17.4996L10.825 17.3329C10.3333 16.4829 9.65829 16.4829 9.16663 17.3329L9.07496 17.4913C8.79996 17.9579 8.36663 18.2913 7.84996 18.4246C7.32496 18.5663 6.78329 18.4913 6.32496 18.2163L4.89163 17.3913C4.38329 17.0996 4.01663 16.6246 3.85829 16.0496C3.70829 15.4746 3.78329 14.8829 4.07496 14.3746C4.31663 13.9496 4.38329 13.5663 4.24163 13.3246C4.09996 13.0829 3.74163 12.9413 3.24996 12.9413C2.03329 12.9413 1.04163 11.9496 1.04163 10.7329V9.26625C1.04163 8.04959 2.03329 7.05792 3.24996 7.05792C3.74163 7.05792 4.09996 6.91625 4.24163 6.67459C4.38329 6.43292 4.32496 6.04959 4.07496 5.62459C3.78329 5.11625 3.70829 4.51625 3.85829 3.94959C4.00829 3.37459 4.37496 2.89959 4.89163 2.60792L6.33329 1.78292C7.27496 1.22459 8.51663 1.54959 9.08329 2.50792L9.18329 2.67459C9.67496 3.52459 10.35 3.52459 10.8416 2.67459L10.9333 2.51625C11.5 1.54959 12.7416 1.22459 13.6916 1.79125L15.125 2.61625C15.6333 2.90792 16 3.38292 16.1583 3.95792C16.3083 4.53292 16.2333 5.12459 15.9416 5.63292C15.7 6.05792 15.6333 6.44125 15.775 6.68292C15.9166 6.92459 16.275 7.06625 16.7666 7.06625C17.9833 7.06625 18.975 8.05792 18.975 9.27459V10.7413C18.975 11.9579 17.9833 12.9496 16.7666 12.9496C16.275 12.9496 15.9166 13.0913 15.775 13.3329C15.6333 13.5746 15.6916 13.9579 15.9416 14.3829C16.2333 14.8913 16.3166 15.4913 16.1583 16.0579C16.0083 16.6329 15.6416 17.1079 15.125 17.3996L13.6833 18.2246C13.3666 18.3996 13.025 18.4913 12.675 18.4913ZM9.99996 15.4079C10.7416 15.4079 11.4333 15.8746 11.9083 16.6996L12 16.8579C12.1 17.0329 12.2666 17.1579 12.4666 17.2079C12.6666 17.2579 12.8666 17.2329 13.0333 17.1329L14.475 16.2996C14.6916 16.1746 14.8583 15.9663 14.925 15.7163C14.9916 15.4663 14.9583 15.2079 14.8333 14.9913C14.3583 14.1746 14.3 13.3329 14.6666 12.6913C15.0333 12.0496 15.7916 11.6829 16.7416 11.6829C17.275 11.6829 17.7 11.2579 17.7 10.7246V9.25792C17.7 8.73292 17.275 8.29959 16.7416 8.29959C15.7916 8.29959 15.0333 7.93292 14.6666 7.29125C14.3 6.64959 14.3583 5.80792 14.8333 4.99125C14.9583 4.77459 14.9916 4.51625 14.925 4.26625C14.8583 4.01625 14.7 3.81625 14.4833 3.68292L13.0416 2.85792C12.6833 2.64125 12.2083 2.76625 11.9916 3.13292L11.9 3.29125C11.425 4.11625 10.7333 4.58292 9.99163 4.58292C9.24996 4.58292 8.55829 4.11625 8.08329 3.29125L7.99163 3.12459C7.78329 2.77459 7.31663 2.64959 6.95829 2.85792L5.51663 3.69125C5.29996 3.81625 5.13329 4.02459 5.06663 4.27459C4.99996 4.52459 5.03329 4.78292 5.15829 4.99959C5.63329 5.81625 5.69163 6.65792 5.32496 7.29959C4.95829 7.94125 4.19996 8.30792 3.24996 8.30792C2.71663 8.30792 2.29163 8.73292 2.29163 9.26625V10.7329C2.29163 11.2579 2.71663 11.6913 3.24996 11.6913C4.19996 11.6913 4.95829 12.0579 5.32496 12.6996C5.69163 13.3413 5.63329 14.1829 5.15829 14.9996C5.03329 15.2163 4.99996 15.4746 5.06663 15.7246C5.13329 15.9746 5.29163 16.1746 5.50829 16.3079L6.94996 17.1329C7.12496 17.2413 7.33329 17.2663 7.52496 17.2163C7.72496 17.1663 7.89163 17.0329 7.99996 16.8579L8.09163 16.6996C8.56663 15.8829 9.25829 15.4079 9.99996 15.4079Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SystemSettingsIcon = ({ width, height, fallbackWidth = 20, fallbackHeight = 20 }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M428.135 338.713H251.114C246.8 338.713 243.302 342.207 243.302 346.525C243.302 350.843 246.8 354.337 251.114 354.337H428.136C432.45 354.337 435.948 350.843 435.948 346.525C435.947 342.207 432.45 338.713 428.135 338.713Z"
        fill="currentColor"
      />
      <path
        d="M83.8569 354.337H97.9209C102.235 354.337 105.733 350.843 105.733 346.525C105.733 342.207 102.235 338.713 97.9209 338.713H83.8569C79.5429 338.713 76.0449 342.207 76.0449 346.525C76.0449 350.843 79.5429 354.337 83.8569 354.337Z"
        fill="currentColor"
      />
      <path
        d="M428.134 445.037H408.837C404.523 445.037 401.025 448.531 401.025 452.849C401.025 457.167 404.523 460.661 408.837 460.661H428.134C432.448 460.661 435.946 457.167 435.946 452.849C435.946 448.531 432.449 445.037 428.134 445.037Z"
        fill="currentColor"
      />
      <path
        d="M83.8569 460.661H255.645C259.959 460.661 263.457 457.167 263.457 452.849C263.457 448.531 259.959 445.037 255.645 445.037H83.8569C79.5429 445.037 76.0449 448.531 76.0449 452.849C76.0449 457.167 79.5429 460.661 83.8569 460.661Z"
        fill="currentColor"
      />
      <path
        d="M479.192 210.768H442.539C437.874 191.688 430.283 173.455 419.904 156.404L445.781 130.389C456.34 119.957 456.407 102.954 445.812 92.366L419.565 66.115C409 55.56 392.009 55.561 381.542 66.139L355.737 92.146C338.995 81.885 320.762 74.287 301.388 69.496V32.892C301.388 18.069 289.3 6.015 274.439 6.015H237.332C222.555 6.015 210.535 18.069 210.535 32.892V69.488C191.016 74.294 172.776 81.893 156.156 92.138L130.263 66.169C120.197 55.908 102.299 55.961 92.3776 66.1L65.9016 92.428C55.6176 102.925 55.6327 119.93 65.9517 130.351L91.9286 156.396C81.5377 173.401 73.9897 191.634 69.4267 210.767H32.8916C18.0726 210.767 6.01465 222.79 6.01465 237.567V256C6.01465 260.318 9.51265 263.812 13.8266 263.812H154.291C158.605 263.812 162.103 260.318 162.103 256C162.103 204.222 204.226 162.103 256 162.103C307.778 162.103 349.901 204.222 349.901 256C349.901 260.318 353.399 263.812 357.713 263.812H498.173C502.487 263.812 505.985 260.318 505.985 256V237.568C505.985 222.791 493.965 210.768 479.192 210.768Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UsersIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.63448 9.68366C7.60948 9.68366 7.59281 9.68366 7.56781 9.68366C7.52615 9.67533 7.46781 9.67533 7.41781 9.68366C5.00115 9.60866 3.17615 7.70866 3.17615 5.36699C3.17615 2.98366 5.11781 1.04199 7.50115 1.04199C9.88448 1.04199 11.8261 2.98366 11.8261 5.36699C11.8178 7.70866 9.98448 9.60866 7.65948 9.68366C7.65115 9.68366 7.64281 9.68366 7.63448 9.68366ZM7.50115 2.29199C5.80948 2.29199 4.42615 3.67533 4.42615 5.36699C4.42615 7.03366 5.72615 8.37533 7.38448 8.43366C7.43448 8.42533 7.54281 8.42533 7.65115 8.43366C9.28448 8.35866 10.5678 7.01699 10.5761 5.36699C10.5761 3.67533 9.19281 2.29199 7.50115 2.29199Z"
        fill="currentColor"
      />
      <path
        d="M13.7844 9.79134C13.7594 9.79134 13.7344 9.79134 13.7094 9.78301C13.3678 9.81634 13.0178 9.57467 12.9844 9.23301C12.9511 8.89134 13.1594 8.58301 13.5011 8.54134C13.6011 8.53301 13.7094 8.53301 13.8011 8.53301C15.0178 8.46634 15.9678 7.46634 15.9678 6.24134C15.9678 4.97467 14.9428 3.94967 13.6761 3.94967C13.3344 3.95801 13.0511 3.67467 13.0511 3.33301C13.0511 2.99134 13.3344 2.70801 13.6761 2.70801C15.6261 2.70801 17.2178 4.29967 17.2178 6.24967C17.2178 8.16634 15.7178 9.71634 13.8094 9.79134C13.8011 9.79134 13.7928 9.79134 13.7844 9.79134Z"
        fill="currentColor"
      />
      <path
        d="M7.64281 18.7913C6.00947 18.7913 4.36781 18.3747 3.12614 17.5413C1.96781 16.7747 1.33447 15.7247 1.33447 14.583C1.33447 13.4413 1.96781 12.383 3.12614 11.608C5.62614 9.94967 9.67614 9.94967 12.1595 11.608C13.3095 12.3747 13.9511 13.4247 13.9511 14.5663C13.9511 15.708 13.3178 16.7663 12.1595 17.5413C10.9095 18.3747 9.27614 18.7913 7.64281 18.7913ZM3.81781 12.658C3.01781 13.1913 2.58447 13.8747 2.58447 14.5913C2.58447 15.2997 3.02614 15.983 3.81781 16.508C5.89281 17.8997 9.39281 17.8997 11.4678 16.508C12.2678 15.9747 12.7011 15.2913 12.7011 14.5747C12.7011 13.8663 12.2595 13.183 11.4678 12.658C9.39281 11.2747 5.89281 11.2747 3.81781 12.658Z"
        fill="currentColor"
      />
      <path
        d="M15.2844 17.2917C14.9928 17.2917 14.7344 17.0917 14.6761 16.7917C14.6094 16.45 14.8261 16.125 15.1594 16.05C15.6844 15.9417 16.1678 15.7333 16.5428 15.4417C17.0178 15.0833 17.2761 14.6333 17.2761 14.1583C17.2761 13.6833 17.0178 13.2333 16.5511 12.8833C16.1844 12.6 15.7261 12.4 15.1844 12.275C14.8511 12.2 14.6344 11.8667 14.7094 11.525C14.7844 11.1917 15.1178 10.975 15.4594 11.05C16.1761 11.2083 16.8011 11.4917 17.3094 11.8833C18.0844 12.4667 18.5261 13.2917 18.5261 14.1583C18.5261 15.025 18.0761 15.85 17.3011 16.4417C16.7844 16.8417 16.1344 17.1333 15.4178 17.275C15.3678 17.2917 15.3261 17.2917 15.2844 17.2917Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CRMIcon = ({
  width,
  height,
  fallbackWidth = 20,
  fallbackHeight = 20,
}) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M350.184 78H164.804C161.044 78 158 75.3078 158 71.995C158 68.6822 161.044 66 164.804 66H350.184C353.944 66 357 68.6822 357 71.995C357 75.3078 353.944 78 350.184 78Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M423.852 482H88.1674C58.8587 482 35.0098 460.939 35.0098 435.057V76.9431C35.0098 51.0608 58.8587 30 88.1674 30H423.852C453.161 30 477.01 51.0608 477.01 76.9431V435.057C477.01 460.939 453.161 482 423.852 482ZM88.1674 40.5966C65.4684 40.5966 47.0092 56.8978 47.0092 76.9431V435.057C47.0092 455.093 65.4684 471.403 88.1674 471.403H423.852C446.551 471.403 465.01 455.093 465.01 435.057V76.9431C465.01 56.8978 446.551 40.5966 423.852 40.5966H88.1674Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M471.02 113.06H41C37.69 113.06 35 110.37 35 107.06C35 103.75 37.69 101.06 41 101.06H471.02C474.33 101.06 477.02 103.75 477.02 107.06C477.02 110.37 474.33 113.06 471.02 113.06Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.87 377.5C114.56 377.5 73.6201 336.56 73.6201 286.25C73.6201 235.93 114.56 195 164.87 195C215.19 195 256.12 235.93 256.12 286.25C256.12 336.56 215.19 377.5 164.87 377.5ZM164.87 207C121.17 207 85.6201 242.55 85.6201 286.25C85.6201 329.95 121.17 365.5 164.87 365.5C208.57 365.5 244.13 329.95 244.13 286.25C244.13 242.55 208.57 207 164.87 207Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.94 353.85C104.45 353.85 102.96 353.29 101.8 352.18C99.4 349.89 99.32 346.1 101.61 343.7L158.88 283.84V201C158.88 197.68 161.56 195 164.87 195C168.19 195 170.87 197.68 170.87 201V286.25C170.87 287.79 170.28 289.28 169.21 290.39L110.28 351.99C109.1 353.23 107.52 353.85 105.94 353.85Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M415.29 258H305.04C301.73 258 299.04 255.31 299.04 252C299.04 248.69 301.73 246 305.04 246H415.29C418.6 246 421.28 248.69 421.28 252C421.28 255.31 418.6 258 415.29 258Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M415.29 325.87H305.04C301.73 325.87 299.04 323.19 299.04 319.87C299.04 316.56 301.73 313.88 305.04 313.88H415.29C418.6 313.88 421.28 316.56 421.28 319.87C421.28 323.19 418.6 325.87 415.29 325.87Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const LogoutIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 14L21.2929 12.7071C21.6834 12.3166 21.6834 11.6834 21.2929 11.2929L20 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12H13M6 20C3.79086 20 2 18.2091 2 16V8C2 5.79086 3.79086 4 6 4M6 20C8.20914 20 10 18.2091 10 16V8C10 5.79086 8.20914 4 6 4M6 20H14C16.2091 20 18 18.2091 18 16M6 4H14C16.2091 4 18 5.79086 18 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const SearchIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1702 18.1253C5.46187 18.1253 1.62854 14.292 1.62854 9.58366C1.62854 4.87533 5.46187 1.04199 10.1702 1.04199C14.8785 1.04199 18.7119 4.87533 18.7119 9.58366C18.7119 14.292 14.8785 18.1253 10.1702 18.1253ZM10.1702 2.29199C6.14521 2.29199 2.87854 5.56699 2.87854 9.58366C2.87854 13.6003 6.14521 16.8753 10.1702 16.8753C14.1952 16.8753 17.4619 13.6003 17.4619 9.58366C17.4619 5.56699 14.1952 2.29199 10.1702 2.29199Z"
        fill="currentColor"
      />
      <path
        d="M18.9202 18.9585C18.7619 18.9585 18.6035 18.9002 18.4785 18.7752L16.8119 17.1085C16.5702 16.8669 16.5702 16.4669 16.8119 16.2252C17.0535 15.9835 17.4535 15.9835 17.6952 16.2252L19.3619 17.8919C19.6035 18.1335 19.6035 18.5335 19.3619 18.7752C19.2369 18.9002 19.0785 18.9585 18.9202 18.9585Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PlusIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TrashIcon = ({ width, height, color = 'currentColor' }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5001 5.60839C17.4834 5.60839 17.4584 5.60839 17.4334 5.60839C13.0251 5.16673 8.62505 5.00006 4.26672 5.44173L2.56672 5.60839C2.21672 5.64173 1.90839 5.39173 1.87505 5.04173C1.84172 4.69173 2.09172 4.39173 2.43339 4.35839L4.13339 4.19173C8.56672 3.74173 13.0584 3.91673 17.5584 4.35839C17.9001 4.39173 18.1501 4.70006 18.1167 5.04173C18.0917 5.36673 17.8167 5.60839 17.5001 5.60839Z"
        fill={color}
      />
      <path
        d="M7.08338 4.76699C7.05005 4.76699 7.01672 4.76699 6.97505 4.75866C6.64172 4.70033 6.40838 4.37533 6.46672 4.04199L6.65005 2.95033C6.78338 2.15033 6.96671 1.04199 8.90838 1.04199H11.0917C13.0417 1.04199 13.225 2.19199 13.35 2.95866L13.5334 4.04199C13.5917 4.38366 13.3584 4.70866 13.025 4.75866C12.6834 4.81699 12.3584 4.58366 12.3084 4.25033L12.125 3.16699C12.0084 2.44199 11.9834 2.30033 11.1 2.30033H8.91672C8.03338 2.30033 8.01672 2.41699 7.89172 3.15866L7.70005 4.24199C7.65005 4.55033 7.38338 4.76699 7.08338 4.76699Z"
        fill={color}
      />
      <path
        d="M12.675 18.9586H7.325C4.41666 18.9586 4.3 17.3503 4.20833 16.0503L3.66666 7.65864C3.64166 7.31697 3.90833 7.01697 4.25 6.99197C4.6 6.97531 4.89166 7.23364 4.91666 7.57531L5.45833 15.967C5.55 17.2336 5.58333 17.7086 7.325 17.7086H12.675C14.425 17.7086 14.4583 17.2336 14.5417 15.967L15.0833 7.57531C15.1083 7.23364 15.4083 6.97531 15.75 6.99197C16.0917 7.01697 16.3583 7.30864 16.3333 7.65864L15.7917 16.0503C15.7 17.3503 15.5833 18.9586 12.675 18.9586Z"
        fill={color}
      />
      <path
        d="M11.3833 14.375H8.60828C8.26661 14.375 7.98328 14.0917 7.98328 13.75C7.98328 13.4083 8.26661 13.125 8.60828 13.125H11.3833C11.7249 13.125 12.0083 13.4083 12.0083 13.75C12.0083 14.0917 11.7249 14.375 11.3833 14.375Z"
        fill={color}
      />
      <path
        d="M12.0833 11.042H7.91663C7.57496 11.042 7.29163 10.7587 7.29163 10.417C7.29163 10.0753 7.57496 9.79199 7.91663 9.79199H12.0833C12.425 9.79199 12.7083 10.0753 12.7083 10.417C12.7083 10.7587 12.425 11.042 12.0833 11.042Z"
        fill={color}
      />
    </svg>
  );
};
export const EditIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.08325 17.9166L6.70764 16.138C7.00343 16.0242 7.15132 15.9673 7.28968 15.8931C7.41259 15.8271 7.52975 15.751 7.63995 15.6654C7.76402 15.5692 7.87606 15.4571 8.10015 15.233L17.4999 5.83326C18.4204 4.91279 18.4204 3.4204 17.4999 2.49993C16.5795 1.57945 15.0871 1.57945 14.1666 2.49992L4.76682 11.8997C4.54273 12.1238 4.43069 12.2358 4.33441 12.3599C4.2489 12.4701 4.17275 12.5873 4.10678 12.7102C4.03251 12.8485 3.97563 12.9964 3.86186 13.2922L2.08325 17.9166ZM2.08325 17.9166L3.79835 13.4574C3.92108 13.1383 3.98245 12.9787 4.0877 12.9057C4.17969 12.8418 4.2935 12.8176 4.4035 12.8386C4.52936 12.8627 4.65024 12.9836 4.89199 13.2253L6.77456 15.1079C7.01631 15.3496 7.13719 15.4705 7.16122 15.5964C7.18223 15.7064 7.15807 15.8202 7.09421 15.9122C7.02112 16.0174 6.86158 16.0788 6.54248 16.2015L2.08325 17.9166Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SaveIcon = ({ width, height, color = 'currentColor' }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 2.5H14.1667L17.5 5.83333V16.6667C17.5 17.5833 16.75 18.3333 15.8333 18.3333H3.33333C2.41667 18.3333 1.66667 17.5833 1.66667 16.6667V4.16667C1.66667 3.25 2.41667 2.5 3.33333 2.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 18.3333V11.6667H5V18.3333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5 2.5V6.66667H12.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CancelIcon = ({ width, height, color = 'currentColor' }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5L15 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 5L5 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EditProductsIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M2.0293 8.5H21.9993"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.0293 15.5H11.9993"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.50977 21.9897V2.00977"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5098 11.9897V2.00977"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M18.7299 14.6701L14.5799 18.82C14.4199 18.98 14.2699 19.29 14.2299 19.51L13.9999 21.1C13.9199 21.67 14.3199 22.08 14.8899 21.99L16.4799 21.76C16.6999 21.73 17.0099 21.5701 17.1699 21.4101L21.3199 17.26C22.0299 16.55 22.3699 15.7101 21.3199 14.6601C20.2799 13.6201 19.4499 13.9501 18.7299 14.6701Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1401 15.26C18.4901 16.52 19.4801 17.5 20.7401 17.86"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FilterIcon = ({ width, height, isActive = false }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 16 16"
      fill={isActive ? 'currentColor' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 3.2H14L9.3 8.6V13.2L6.7 11.8V8.6L2 3.2Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SortingIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8501 5L8.1001 1.25L4.3501 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.3501 10L8.1001 13.75L11.8501 10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AscendingIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.3501 10L8.1001 13.75L11.8501 10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DecendingIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8501 5L8.1001 1.25L4.3501 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CrossIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UploadIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3337 13.3333L10.0003 10L6.66699 13.3333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10V17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9919 15.3249C17.8047 14.8818 18.4467 14.1806 18.8168 13.3321C19.1868 12.4835 19.2637 11.5359 19.0354 10.6388C18.807 9.7417 18.2865 8.94616 17.5558 8.37778C16.8251 7.80939 15.9259 7.50052 15.0002 7.4999H13.9502C13.698 6.52427 13.2278 5.61852 12.5752 4.85073C11.9225 4.08295 11.1043 3.47311 10.182 3.06708C9.25967 2.66104 8.25734 2.46937 7.25031 2.50647C6.24328 2.54358 5.25777 2.80849 4.36786 3.28129C3.47795 3.7541 2.7068 4.42249 2.1124 5.23622C1.51799 6.04996 1.11579 6.98785 0.936028 7.9794C0.756269 8.97095 0.803632 9.99035 1.07456 10.961C1.34548 11.9316 1.83291 12.8281 2.50021 13.5832"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 13.3333L10.0003 10L6.66699 13.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DownloadIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_589_3203)">
        <path
          d="M8 17L12 21L16 17"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12V21"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8802 18.0899C21.7496 17.4786 22.4015 16.6061 22.7415 15.5991C23.0814 14.5921 23.0916 13.503 22.7706 12.4898C22.4496 11.4766 21.814 10.592 20.9562 9.96449C20.0985 9.33697 19.063 8.9991 18.0002 8.99993H16.7402C16.4394 7.82781 15.8767 6.73918 15.0943 5.81601C14.3119 4.89285 13.3303 4.15919 12.2234 3.67029C11.1164 3.18138 9.91302 2.94996 8.7037 2.99345C7.49439 3.03694 6.31069 3.3542 5.24173 3.92136C4.17277 4.48851 3.2464 5.29078 2.53236 6.26776C1.81833 7.24474 1.33523 8.37098 1.11944 9.56168C0.903647 10.7524 0.960787 11.9765 1.28656 13.142C1.61233 14.3074 2.19824 15.3837 3.00018 16.2899"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_589_3203">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CrossRoundIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2984 15.3588C14.5913 15.6517 15.0662 15.6517 15.3591 15.3588C15.652 15.0659 15.652 14.591 15.3591 14.2982L13.061 12.0001L15.3591 9.70209C15.652 9.4092 15.652 8.93433 15.3591 8.64143C15.0662 8.34854 14.5913 8.34854 14.2984 8.64143L12.0004 10.9395L9.70222 8.6413C9.40933 8.34841 8.93445 8.34841 8.64156 8.6413C8.34867 8.93419 8.34867 9.40907 8.64156 9.70196L10.9397 12.0001L8.64154 14.2983C8.34865 14.5912 8.34865 15.0661 8.64154 15.3589C8.93444 15.6518 9.40931 15.6518 9.70221 15.3589L12.0004 13.0608L14.2984 15.3588Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BankIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3082 1.79121L17.8082 4.79119C18.0998 4.90786 18.3332 5.25785 18.3332 5.56618V8.33286C18.3332 8.79119 17.9582 9.16619 17.4998 9.16619H2.49984C2.0415 9.16619 1.6665 8.79119 1.6665 8.33286V5.56618C1.6665 5.25785 1.89984 4.90786 2.19151 4.79119L9.69151 1.79121C9.85818 1.72454 10.1415 1.72454 10.3082 1.79121Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3332 18.3333H1.6665V15.8333C1.6665 15.375 2.0415 15 2.49984 15H17.4998C17.9582 15 18.3332 15.375 18.3332 15.8333V18.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M3.3335 15.0003V9.16699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.6665 15.0003V9.16699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10 15.0003V9.16699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13.3335 15.0003V9.16699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M16.6665 15.0003V9.16699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.833496 18.333H19.1668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10 7.08301C10.6904 7.08301 11.25 6.52336 11.25 5.83301C11.25 5.14265 10.6904 4.58301 10 4.58301C9.30964 4.58301 8.75 5.14265 8.75 5.83301C8.75 6.52336 9.30964 7.08301 10 7.08301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CallIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3082 15.2753C18.3082 15.5753 18.2415 15.8837 18.0998 16.1837C17.9582 16.4837 17.7748 16.767 17.5332 17.0337C17.1248 17.4837 16.6748 17.8087 16.1665 18.017C15.6665 18.2253 15.1248 18.3337 14.5415 18.3337C13.6915 18.3337 12.7832 18.1337 11.8248 17.7253C10.8665 17.317 9.90817 16.767 8.95817 16.0753C7.99984 15.3753 7.0915 14.6003 6.22484 13.742C5.3665 12.8753 4.5915 11.967 3.89984 11.017C3.2165 10.067 2.6665 9.11699 2.2665 8.17533C1.8665 7.22533 1.6665 6.31699 1.6665 5.45033C1.6665 4.88366 1.7665 4.34199 1.9665 3.84199C2.1665 3.33366 2.48317 2.86699 2.92484 2.45033C3.45817 1.92533 4.0415 1.66699 4.65817 1.66699C4.8915 1.66699 5.12484 1.71699 5.33317 1.81699C5.54984 1.91699 5.7415 2.06699 5.8915 2.28366L7.82484 5.00866C7.97484 5.21699 8.08317 5.40866 8.15817 5.59199C8.23317 5.76699 8.27484 5.94199 8.27484 6.10033C8.27484 6.30033 8.2165 6.50033 8.09984 6.69199C7.9915 6.88366 7.83317 7.08366 7.63317 7.28366L6.99984 7.94199C6.90817 8.03366 6.8665 8.14199 6.8665 8.27533C6.8665 8.34199 6.87484 8.40033 6.8915 8.46699C6.9165 8.53366 6.9415 8.58366 6.95817 8.63366C7.10817 8.90866 7.3665 9.26699 7.73317 9.70033C8.10817 10.1337 8.50817 10.5753 8.9415 11.017C9.3915 11.4587 9.82484 11.867 10.2665 12.242C10.6998 12.6087 11.0582 12.8587 11.3415 13.0087C11.3832 13.0253 11.4332 13.0503 11.4915 13.0753C11.5582 13.1003 11.6248 13.1087 11.6998 13.1087C11.8415 13.1087 11.9498 13.0587 12.0415 12.967L12.6748 12.342C12.8832 12.1337 13.0832 11.9753 13.2748 11.8753C13.4665 11.7587 13.6582 11.7003 13.8665 11.7003C14.0248 11.7003 14.1915 11.7337 14.3748 11.8087C14.5582 11.8837 14.7498 11.992 14.9582 12.1337L17.7165 14.092C17.9332 14.242 18.0832 14.417 18.1748 14.6253C18.2582 14.8337 18.3082 15.042 18.3082 15.2753Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export const FolderIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3332 9.16699V14.167C18.3332 17.5003 17.4998 18.3337 14.1665 18.3337H5.83317C2.49984 18.3337 1.6665 17.5003 1.6665 14.167V5.83366C1.6665 2.50033 2.49984 1.66699 5.83317 1.66699H7.08317C8.33317 1.66699 8.60817 2.03366 9.08317 2.66699L10.3332 4.33366C10.6498 4.75033 10.8332 5.00033 11.6665 5.00033H14.1665C17.4998 5.00033 18.3332 5.83366 18.3332 9.16699Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export const CDRIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9H9H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2V8H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ExtensionIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_595_81)">
        <path
          d="M18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 9H9V15H15V9Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 1V4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 1V4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 20V23"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 20V23"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 9H23"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 14H23"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 9H4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 14H4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_595_81">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const BillingInfoIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.05811 2.08301V12.058C3.05811 12.8747 3.44144 13.6497 4.09977 14.1413L8.44143 17.3913C9.36643 18.083 10.6414 18.083 11.5664 17.3913L15.9081 14.1413C16.5664 13.6497 16.9498 12.8747 16.9498 12.058V2.08301H3.05811Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M1.6665 2.08301H18.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        opacity="0.4"
        d="M6.6665 6.66699H13.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.6665 10.833H13.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InvoicingIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 5.83366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V5.83366C2.5 3.33366 3.75 1.66699 6.66667 1.66699H13.3333C16.25 1.66699 17.5 3.33366 17.5 5.83366Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M12.9163 1.66699V8.21698C12.9163 8.58365 12.483 8.76698 12.2163 8.52531L10.283 6.74201C10.1247 6.59201 9.87465 6.59201 9.71632 6.74201L7.78303 8.52531C7.51636 8.76698 7.08301 8.58365 7.08301 8.21698V1.66699H12.9163Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.042 11.667H14.5837"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.5 15H14.5833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AllocatePackIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0833 6.06527L9.99997 10.0005M9.99997 10.0005L2.91664 6.06527M9.99997 10.0005L10 17.9171M17.5 13.3826V6.61835C17.5 6.33281 17.5 6.19004 17.4579 6.06271C17.4207 5.95007 17.3599 5.84666 17.2795 5.75942C17.1886 5.66081 17.0638 5.59147 16.8142 5.4528L10.6475 2.02688C10.4112 1.89558 10.293 1.82993 10.1679 1.80419C10.0571 1.78141 9.94288 1.78141 9.83213 1.80419C9.70698 1.82993 9.58881 1.89558 9.35248 2.02688L3.18581 5.45281C2.93621 5.59148 2.8114 5.66081 2.72053 5.75942C2.64013 5.84667 2.57929 5.95007 2.54207 6.06271C2.5 6.19005 2.5 6.33281 2.5 6.61835V13.3826C2.5 13.6681 2.5 13.8109 2.54207 13.9382C2.57929 14.0509 2.64013 14.1543 2.72053 14.2415C2.8114 14.3401 2.93621 14.4095 3.18581 14.5481L9.35248 17.9741C9.58881 18.1054 9.70698 18.171 9.83213 18.1968C9.94288 18.2195 10.0571 18.2195 10.1679 18.1968C10.293 18.171 10.4112 18.1054 10.6475 17.9741L16.8142 14.5481C17.0638 14.4095 17.1886 14.3401 17.2795 14.2415C17.3599 14.1543 17.4207 14.0509 17.4579 13.9382C17.5 13.8109 17.5 13.6681 17.5 13.3826Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 7.91667L6.25 3.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Setting2Icon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8335 5.83366V1.66699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.3337V14.167"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.1665 5.83366V1.66699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M4.1665 18.3337V9.16699"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 9.16699H5.83333"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g opacity="0.4">
        <path
          d="M15.833 18.3337V9.16699"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1665 9.16699H17.4998"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g opacity="0.4">
        <path
          d="M10 10.8337V1.66699"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.3335 10.834H11.6668"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const DownlaodFileIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M30.75 15.285H26.415C22.86 15.285 19.965 12.39 19.965 8.835V4.5C19.965 3.675 19.29 3 18.465 3H12.105C7.485 3 3.75 6 3.75 11.355V24.645C3.75 30 7.485 33 12.105 33H23.895C28.515 33 32.25 30 32.25 24.645V16.785C32.25 15.96 31.575 15.285 30.75 15.285Z"
        fill="currentColor"
      />
      <path
        d="M23.7 3.31475C23.085 2.69975 22.02 3.11975 22.02 3.97475V9.20974C22.02 11.3997 23.88 13.2147 26.145 13.2147C27.57 13.2297 29.55 13.2297 31.245 13.2297C32.1 13.2297 32.55 12.2247 31.95 11.6247C29.79 9.44975 25.92 5.53475 23.7 3.31475Z"
        fill="currentColor"
      />
      <path
        d="M9.70501 23.295L12.705 26.295C12.72 26.31 12.735 26.31 12.735 26.325C12.825 26.415 12.945 26.49 13.065 26.55C13.08 26.55 13.08 26.55 13.095 26.55C13.215 26.595 13.335 26.61 13.455 26.625C13.5 26.625 13.53 26.625 13.575 26.625C13.665 26.625 13.77 26.595 13.86 26.565C13.905 26.55 13.935 26.535 13.965 26.52C14.085 26.46 14.205 26.4 14.295 26.295L17.295 23.295C17.73 22.86 17.73 22.14 17.295 21.705C16.86 21.27 16.14 21.27 15.705 21.705L14.625 22.785V16.5C14.625 15.885 14.115 15.375 13.5 15.375C12.885 15.375 12.375 15.885 12.375 16.5V22.785L11.295 21.705C11.07 21.48 10.785 21.375 10.5 21.375C10.215 21.375 9.93001 21.48 9.70501 21.705C9.27001 22.14 9.27001 22.86 9.70501 23.295Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const OtherSiteIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_589_1348)">
        <path
          d="M6.51621 18.3337H13.4835C15.4074 18.3337 16.9671 16.8453 16.9671 15.0093V10.9445C16.9671 10.3543 17.2128 9.78832 17.6501 9.37099C18.6633 8.40408 18.5316 6.80203 17.3727 5.99775L12.0488 2.30282C10.8273 1.45505 9.1724 1.45505 7.95087 2.30282L2.62693 5.99776C1.46806 6.80203 1.33634 8.40408 2.34958 9.37099C2.7869 9.78832 3.03259 10.3543 3.03259 10.9445V15.0093C3.03259 16.8453 4.59226 18.3337 6.51621 18.3337Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M11.6665 13.3337C11.6665 14.2541 10.9203 15.0003 9.99984 15.0003C9.07936 15.0003 8.33317 14.2541 8.33317 13.3337C8.33317 12.4132 9.07936 11.667 9.99984 11.667C10.9203 11.667 11.6665 12.4132 11.6665 13.3337Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_589_1348">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CommentIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.6665 8.33333H13.3332M6.6665 11.6667H9.99984M9.1665 2.5H10.8332C14.9753 2.5 18.3332 5.85786 18.3332 10C18.3332 14.1421 14.9753 17.5 10.8332 17.5H4.99984C3.15889 17.5 1.6665 16.0076 1.6665 14.1667V10C1.6665 5.85786 5.02437 2.5 9.1665 2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const TickCircleIcon = ({ width, height, color }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.4"
        cx="12"
        cy="12"
        r="10"
        transform="rotate(180 12 12)"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5018 2.44254C22.8096 2.71963 22.8346 3.19385 22.5575 3.50173L13.8199 13.0991C12.8454 14.1819 11.1955 14.3168 10.0579 13.4068L6.53151 10.5857C6.20806 10.3269 6.15562 9.85493 6.41438 9.53149C6.67313 9.20804 7.1451 9.1556 7.46855 9.41436L10.995 12.2355C11.512 12.6492 12.262 12.5878 12.705 12.0956L21.4426 2.49828C21.7197 2.1904 22.1939 2.16544 22.5018 2.44254Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};
export const DownlaodIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_589_4365)">
        <path
          d="M6.66699 14.167L10.0003 17.5003L13.3337 14.167"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10V17.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4003 15.0749C18.1248 14.5655 18.6681 13.8384 18.9514 12.9992C19.2347 12.1601 19.2432 11.2525 18.9756 10.4081C18.7081 9.5638 18.1785 8.82669 17.4637 8.30375C16.7489 7.7808 15.886 7.49925 15.0003 7.49994H13.9503C13.6997 6.52317 13.2307 5.61598 12.5787 4.84668C11.9268 4.07737 11.1088 3.46599 10.1863 3.05857C9.26387 2.65115 8.26101 2.4583 7.25325 2.49454C6.24548 2.53078 5.25907 2.79517 4.36827 3.2678C3.47747 3.74043 2.7055 4.40898 2.11047 5.22314C1.51544 6.03729 1.11285 6.97582 0.933028 7.96807C0.753202 8.96032 0.800819 9.98044 1.07229 10.9516C1.34377 11.9228 1.83203 12.8198 2.50031 13.5749"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_589_4365">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FileIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4515 18.3337H13.4515C17.6182 18.3337 19.2848 16.667 19.2848 12.5003V7.50033C19.2848 3.33366 17.6182 1.66699 13.4515 1.66699H8.4515C4.28483 1.66699 2.61816 3.33366 2.61816 7.50033V12.5003C2.61816 16.667 4.28483 18.3337 8.4515 18.3337Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M14.0762 7.5H7.82617"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M14.0762 12.5H7.82617"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RefreshIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 10C22 10 19.995 7.26822 18.3662 5.63824C16.7373 4.00827 14.4864 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.1031 21 19.5649 18.2543 20.6482 14.5M22 10V4M22 10H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SearchFileIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.502 11.3449V7.08493C20.502 3.05493 19.562 2.04492 15.782 2.04492H8.22195C4.44195 2.04492 3.50195 3.05493 3.50195 7.08493V18.3449C3.50195 21.0049 4.96196 21.6349 6.73196 19.7349L6.74194 19.7249C7.56194 18.8549 8.81194 18.9249 9.52194 19.8749L10.532 21.2249"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.202 21.4449C19.9693 21.4449 21.4019 20.0122 21.4019 18.2449C21.4019 16.4776 19.9693 15.0449 18.202 15.0449C16.4347 15.0449 15.002 16.4776 15.002 18.2449C15.002 20.0122 16.4347 21.4449 18.202 21.4449Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.002 22.0449L21.002 21.0449"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.00195 7.04492H16.002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.00195 11.0449H15.002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ErrorIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="17" r="1" fill="currentColor" />
      <path
        d="M11.9999 8.99997V14M4.32789 21H19.6721C21.4445 21 22.5649 19.1433 21.7041 17.6324L14.032 4.16592C13.1464 2.61136 10.8536 2.61136 9.96798 4.16592L2.29587 17.6324C1.4351 19.1433 2.55546 21 4.32789 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UnauthroziedIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84286 16.1566 4 14.1217 4 12C3.9978 10.2233 4.59302 8.49755 5.69 7.1L16.9 18.31C15.5025 19.407 13.7767 20.0022 12 20ZM18.31 16.9L7.1 5.69C8.49755 4.59302 10.2233 3.99779 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1572 7.84344 20 9.87827 20 12C20.0022 13.7767 19.407 15.5025 18.31 16.9Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RoleIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4901 2.23006L5.50015 4.10005C4.35015 4.53005 3.41016 5.89004 3.41016 7.12004V14.55C3.41016 15.73 4.19017 17.28 5.14017 17.99L9.44016 21.2001C10.8502 22.2601 13.1701 22.2601 14.5801 21.2001L18.8802 17.99C19.8302 17.28 20.6101 15.73 20.6101 14.55V7.12004C20.6101 5.89004 19.6701 4.53005 18.5201 4.10005L13.5302 2.23006C12.6802 1.92006 11.3201 1.92006 10.4901 2.23006Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M12.0002 10.9199C11.9602 10.9199 11.9102 10.9199 11.8702 10.9199C10.9302 10.8899 10.1802 10.1099 10.1802 9.15991C10.1802 8.18991 10.9702 7.3999 11.9402 7.3999C12.9102 7.3999 13.7002 8.18991 13.7002 9.15991C13.6902 10.1199 12.9402 10.8899 12.0002 10.9199Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10.01 13.7201C9.05004 14.3601 9.05004 15.4101 10.01 16.0501C11.1 16.7801 12.89 16.7801 13.98 16.0501C14.94 15.4101 14.94 14.3601 13.98 13.7201C12.9 12.9901 11.11 12.9901 10.01 13.7201Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EyeIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 20.27C15.5298 20.27 18.8198 18.19 21.1098 14.59C22.0098 13.18 22.0098 10.81 21.1098 9.39997C18.8198 5.79997 15.5298 3.71997 11.9998 3.71997C8.46984 3.71997 5.17984 5.79997 2.88984 9.39997C1.98984 10.81 1.98984 13.18 2.88984 14.59C5.17984 18.19 8.46984 20.27 11.9998 20.27Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EyeOffIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.41992 19.5302C9.55992 20.0102 10.7699 20.2702 11.9999 20.2702C15.5299 20.2702 18.8199 18.1902 21.1099 14.5902C22.0099 13.1802 22.0099 10.8102 21.1099 9.40018C20.7799 8.88018 20.4199 8.39018 20.0499 7.93018"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.5099 12.7002C15.2499 14.1102 14.0999 15.2602 12.6899 15.5202"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.47 14.5298L2 21.9998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9998 2L14.5298 9.47"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BlockIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93 4.93L19.07 19.07M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChangeStatusIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.11003 11.85C5.29003 12.05 5.30003 16.15 8.11003 16.35H14.78C15.59 16.36 16.37 16.05 16.97 15.51C18.95 13.78 17.8901 10.31 15.2901 9.98001C14.3601 4.34001 6.21006 6.48 8.14006 11.85"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M2 15C2 18.87 5.13 22 9 22L7.95001 20.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 9C22 5.13 18.87 2 15 2L16.05 3.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const OtherSitesIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M15 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15M7 12L17 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PasswordIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.9965 16H16.0054"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.9955 16H12.0045"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.99451 16H8.00349"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DashboardIcon = ({ width, height }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <rect x="3" y="3" width="7" height="7"></rect>
      <rect x="14" y="3" width="7" height="7"></rect>
      <rect x="14" y="14" width="7" height="7"></rect>
      <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
  );
};
export const NonRecurringIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.002 22.75H9.00195C3.57195 22.75 1.25195 20.43 1.25195 15V9C1.25195 3.57 3.57195 1.25 9.00195 1.25H15.002C20.432 1.25 22.752 3.57 22.752 9V15C22.752 20.43 20.432 22.75 15.002 22.75ZM9.00195 2.75C4.39195 2.75 2.75195 4.39 2.75195 9V15C2.75195 19.61 4.39195 21.25 9.00195 21.25H15.002C19.612 21.25 21.252 19.61 21.252 15V9C21.252 4.39 19.612 2.75 15.002 2.75H9.00195Z"
        fill="#3D4754"
      />
      <path
        d="M17.502 12C17.502 15.04 15.042 17.5 12.002 17.5C8.96195 17.5 7.11194 14.44 7.11194 14.44M7.11194 14.44H9.59195M7.11194 14.44V17.19M6.50195 12C6.50195 8.96 8.94195 6.5 12.002 6.5C15.672 6.5 17.502 9.56 17.502 9.56M17.502 9.56V6.81M17.502 9.56H15.062"
        stroke="#3D4754"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NetworkIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 3.30005H7L2 12L7 20.7001H17L22 12L17 3.30005Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.9001 14H7.0001L5.1001 17.3L7.0001 20.7H10.9001L12.8001 17.3L10.9001 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.2999 8H6.9999L3.3999 14.3L6.9999 20.7H14.2999L17.9999 14.3L14.2999 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export const NotificationIcon = ({ width, height }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
  );
};
export const SendIcon = ({ width, height }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
  );
};
export const InfoIcon = ({ width, height }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );
};
export const InvoiceDownloadIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"></path>
    </svg>
  );
};

export const BarChartSkeleton = ({ barCount = 12 }) => {
  const barWidth = 30;
  const gap = 20;
  const totalWidth = barCount * (barWidth + gap);
  const svgHeight = 420;

  const bars = Array.from({ length: barCount })
    .map((_, i) => {
      const x = i * (barWidth + gap) + 40;
      const height = 100 + Math.random() * 120;
      const y = svgHeight - height - 40;
      return `<rect x="${x}" y="${y}" width="${barWidth}" height="${height}" rx="4" />`;
    })
    .join('');

  return (
    <svg
      width="100%"
      height={svgHeight}
      viewBox={`0 0 ${totalWidth + 80} ${svgHeight}`}
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id="shimmer">
          <stop offset="0%" stopColor="#eeeeee" />
          <stop offset="50%" stopColor="#dddddd" />
          <stop offset="100%" stopColor="#eeeeee" />
        </linearGradient>
        <clipPath id="bars" dangerouslySetInnerHTML={{ __html: bars }} />
      </defs>
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill="url(#shimmer)"
        clipPath="url(#bars)"
      >
        <animate
          attributeName="x"
          from="-600"
          to="600"
          dur="2s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
};

/**
 * "Go to" — an arrow leaving an open-sided box. Used for a row action that
 * takes you into the record itself rather than editing it in place.
 */
export const GoToIcon = ({ width, height }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* box, open at the top-right corner the arrow leaves through */}
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      {/* arrow head, then its shaft */}
      <path d="M15 3h6v6" />
      <path d="M10 14 21 3" />
    </svg>
  );
};
